module.exports = __webpack_public_path__ + "static/media/Portrait-10266.b59d18a5.jpg";